<template>
  <ion-page class="essay-generate flex-column align-center" @click="closePop">
    <!--背景-->
    <img
      class="essay-generate_bg"
      :src="getBrandImageUrl('ai_smart_reading/word_check_bg.png')"
      alt=""
    />
    <!--标题 & 返回按钮 & 右上角参数图标-->
    <div class="essay-generate_header flex-row align-center justify-between mb-8">
      <img
        class="essay-generate_header-back cursor-pointer"
        :src="getBrandImageUrl('ai_smart_reading/nav_back.png')"
        alt=""
        @click="onClose"
      />
      <div class="right-bar flex-row flex-shrink-0">
        <div class="right-bar_icon cursor-pointer" title="生词识记" @click="openNine">
          <img class="normal-img" :src="getBrandImageUrl('reading/reading_icon_1.png')" alt="" />
        </div>
        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="单词收藏"
          @click="openReadingPersonalVocabulary"
        >
          <img class="normal-img" :src="getBrandImageUrl('reading/reading_icon_2.png')" alt="" />
        </div>

        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="段落翻译"
          @click="showTranslation(3)"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(3) }"
            :src="getBrandImageUrl('reading/reading_icon_3.png')"
            alt=""
          />
        </div>

        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="逐句翻译"
          @click="showTranslation2(4)"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(4) }"
            :src="getBrandImageUrl('reading/reading_icon_4.png')"
            alt=""
          />
        </div>

        <div class="right-bar_icon cursor-pointer ml-4" title="段落大意" @click="showKnowledge(5)">
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(5) }"
            :src="getBrandImageUrl('reading/reading_icon_5.png')"
            alt=""
          />
        </div>

        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="答题解析"
          @click="showExamination(6)"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(6) }"
            :src="getBrandImageUrl('reading/reading_icon_6.png')"
            alt=""
          />
        </div>

        <div class="right-bar_icon cursor-pointer ml-4" title="句子定位" @click="showFocus(7)">
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(7) }"
            :src="getBrandImageUrl('reading/reading_icon_7.png')"
            alt=""
          />
        </div>

        <div class="right-bar_icon cursor-pointer ml-4" title="句子转换" @click="showNextFocus(8)">
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes(8) }"
            :src="getBrandImageUrl('reading/reading_icon_8.png')"
            alt=""
          />
        </div>

        <div class="right-bar_drop cursor-pointer ml-4" title="字号切换">
          <img
            class="right-bar_icon-image"
            :src="getBrandImageUrl('reading/reading_icon_9.png')"
            alt=""
            @click="changeFontSize"
          />
          <div
            class="right-bar_drop_options flex-column"
            :class="{ options_active: selectOptionsVisible }"
          >
            <span
              v-for="(size, index) in ['小', '中', '大']"
              :key="index"
              :class="{ 'checked-size': currentSize === size }"
              @click="changeFontStyle(size)"
              >{{ size }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!--markdown文章-->
    <div class="essay-generate_main flex-column align-center">
      <div class="essay-generate_content">
        <ion-content>
          <div ref="articleTitle" class="english-font1">
            <h2 class="title">{{ dataObject.title }}</h2>
            <p class="translation3">
              <span class="titleTranslation">{{ dataObject.titleTranslation }}</span>
            </p>
            <!--教案-->
            <div class="articleBody"></div>
            <div id="examination" class="examination mb-5"></div>
            <div id="knowledge" class="knowledge"></div>
          </div>
        </ion-content>
      </div>
    </div>
    <div class="essay-generate_bottom flex-row align-center">
      <div style="width: 100%; display: flex; justify-content: center">
        <ion-button class="button-outline hollow" shape="round" @click="finishReadingArticleLearning"
          >结束练习并创建抗遗忘
        </ion-button>
      </div>
    </div>
  </ion-page>
  <AnswerPop
    v-if="!examinationVisible"
    v-model:show="answerPopVisible"
    :answer-pop-data="answerPopId"
  ></AnswerPop>
</template>
<script>
/* eslint-disable */

import {
  actionSheetController,
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonToolbar,
  modalController,
  popoverController,
  toastController,
} from "@ionic/vue"

import TextComponent from "@/components/MarkdownText.vue"
import { chevronBackOutline } from "ionicons/icons"
import Popover from "./Popover.vue"
import ReadingPersonalVocabulary from "./ReadingPersonalVocabulary.vue"
import Five from "@/views/speed/Five"
import Nine from "@/views/speed/Nine"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import AnswerPop from "@/views/reading/AnswerPop.vue"

function myCreateElement(str, ...cls) {
  let el = document.createElement(str)
  el.classList.add(...cls)
  return el
}

export default {
  name: "ReadingArticle",
  props: ["readingId"],
  components: {
    AnswerPop,
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonButtons,
    IonIcon,
    TextComponent,
  },
  setup() {
    return {
      chevronBackOutline,
    }
  },

  data() {
    return {
      dataObject: {},
      translationVisible: true, //翻译展示开关
      translationVisible2: true, //翻译展示开关
      knowledgeVisible: true, //知识点展示开关
      examinationVisible: true, //测试题展示开关
      focusVisible: true, //句子焦点展示开关
      switchTranslationText: "显示翻译",
      timerTouchstart: undefined, //模拟长按事件定时器

      strTime1: "10:00",
      strTime2: "00:00",
      timerUnlock1: 600,
      timerUnlock2: 0,
      buttonVisible: true,

      examinationDataTable: [], //完形填空测试题答案对照表
      brandImages: BRAND_IMAGES, // 品牌图片数据
      selectOptionsVisible: false,
      fontStyle: { "font-size": "1.1em" },
      clickedArr: [], // 点击的操作图标数组
      currentSize: "小",

      timeout: false,
      answerPopVisible: false,
      answerPopId: null,
    }
  },

  methods: {
    getBrandImageUrl,

    handleClickedFunction(str) {
      // 两个翻译冲突，显示一个另一个不显示
      if (str === 3) {
        this.clickedArr = this.clickedArr.filter((i) => i !== 4)
      } else if (str === 4) {
        this.clickedArr = this.clickedArr.filter((i) => i !== 3)
      }
      if (this.clickedArr.includes(str)) {
        // 点击过的再次点击不显示
        this.clickedArr.splice(this.clickedArr.indexOf(str), 1)
      } else {
        this.clickedArr.push(str)
      }
    },

    changeFontSize() {
      this.selectOptionsVisible = !this.selectOptionsVisible
    },

    changeFontStyle(size) {
      this.currentSize = size
      if (size === "小") {
        this.setFontSize("english-font1")
      } else if (size === "中") {
        this.setFontSize("english-font2")
      } else if (size === "大") {
        this.setFontSize("english-font3")
      }
      this.changeFontSize()
    },

    //弹出"继续练习"，"结束资料"对话框
    async myAlert() {
      return new Promise(async (resolve) => {
        const alert = await alertController.create({
          header: "警告",
          message: "建议点击“完成练习”按钮进行退出，强行退出不会生成练习记录！",
          backdropDismiss: false,
          buttons: [
            {
              text: "强行退出",
              handler: () => {
                resolve(true)
              },
            },
            {
              text: "继续练习",
              handler: () => {
                resolve(false)
              },
            },
          ],
        })
        await alert.present()
      })
    },

    async onClose() {
      if (await this.myAlert()) {
        await modalController.dismiss()
      } else {
        await alertController.dismiss()
      }
    },

    //开始一篇文章的练习
    startReadingArticleLearning() {
      const appointment = this.store.getAppointment()
      this.ajax.post("/reading/startReadingArticleLearning", {
        readingId: this.readingId,
        studentId: appointment.studentId,
      })
    },

    //结束一篇文章的练习
    finishReadingArticleLearning() {
      const appointment = this.store.getAppointment()
      this.ajax
        .post("/reading/finishReadingArticleLearning", {
          readingId: this.readingId,
          studentId: appointment.studentId,
          aptmId: appointment.aptmId,
        })
        .then((res) => {
          if (res.data.success) {
            modalController.dismiss("FINISHED")
          }
        })


      this.createForget()
    },

    //#######################  创建抗遗忘 #####################
    requestGenerateForget(params) {
      return new Promise((resolve) => {
        if (!this.timeout) {
          this.timeout = true
          setTimeout(() => {
            this.timeout = false
          }, 500)
          this.ajax.post("/forget/generateForget", params).then(async (res) => {
            if (res.data.success) {
              await this.alert("21天抗遗忘创建成功。")
              resolve()
            }
          })
        }
      })
    },

    //显示选择资料列表
    async showTeacherSelect(aptmId) {
      return new Promise(async (resolve) => {
        let buttons = []
        for (let i = 5; i < 24; i++) {
          let fill = i < 10 ? "0" : ""
          let time1 = fill + i + ":00"
          let time2 = fill + i + ":30"
          let params1 = { aptmId: aptmId, startTime: time1 }
          let params2 = { aptmId: aptmId, startTime: time2 }
          buttons.push({
            text: time1,
            handler: async () => {
              await this.requestGenerateForget(params1)
              resolve()
            },
          })

          buttons.push({
            text: time2,
            cssClass: "teacherSelectButtons",
            handler: async () => {
              await this.requestGenerateForget(params2)
              resolve()
            },
          })
        }
        const actionSheet = await actionSheetController.create({
          header: "选择抗遗忘时间 ",
          buttons: buttons,
        })

        await actionSheet.present()
      })
    },

    //创建抗遗忘
    async createForget() {
      const appointment = this.store.getAppointment()
      await this.showTeacherSelect(appointment.aptmId)
    },

    //#######################  创建抗遗忘 #####################

    setFontSize(cssClass) {
      document.querySelectorAll(".english").forEach((el) => {
        el.classList.remove("english-font1")
        el.classList.remove("english-font2")
        el.classList.remove("english-font3")
        el.classList.add(cssClass)
      })
      if (this.$refs.articleTitle) {
        this.$refs.articleTitle.classList.remove("english-font1")
        this.$refs.articleTitle.classList.remove("english-font2")
        this.$refs.articleTitle.classList.remove("english-font3")
        this.$refs.articleTitle.classList.add(cssClass)
      }
    },

    async openPopover(ev, word) {
      const popover = await popoverController.create({
        component: Popover,
        componentProps: { word: word },
        event: ev,
        translucent: true,
        cssClass: "popover_class",
      })
      await popover.present()
      //const {role} = await popover.onDidDismiss();
      await popover.onDidDismiss()
      ev.target.classList.remove("focusWord")
    },

    async openReadingPersonalVocabulary() {
      const modal = await modalController.create({
        component: ReadingPersonalVocabulary,
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    changeCourse() {
      return new Promise((resolve) => {
        const appointment = this.store.getAppointment()
        this.ajax
          .post("/course/changeCourseReading", { aptmId: appointment.aptmId })
          .then((res) => {
            if (res.data.success) {
              resolve()
            }
          })
      })
    },

    //打开9宫格，开始上课
    async openNine() {
      await this.changeCourse()
      let studentId = this.store.getStudentId()
      const modal = await modalController.create({
        component: Nine,
        componentProps: { studentId: studentId, readingId: this.readingId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    //打开5滴图，开始上课
    async openSpeedIndex() {
      let studentId = this.store.getStudentId()
      const modal = await modalController.create({
        component: Five,
        componentProps: { studentId: studentId },
        cssClass: "modal_controller_class",
      })

      this.inClass = true
      await modal.present()
      await modal.onDidDismiss()
      this.inClass = false
    },

    //滚动到焦点处
    scrollToFocus() {
      const contentList = document.querySelectorAll(".content")
      for (let i = 0; i < contentList.length; i++) {
        if (contentList[i].classList.contains("contentFocus")) {
          contentList[i].scrollIntoView(false)
          break
        }
      }
    },

    //2合1，控制翻译是否显示
    showTranslation(num) {
      // 记录点击功能图标
      this.handleClickedFunction(num)
      //激活另一个按钮
      this.translationVisible2 = true

      //无翻译在显示
      if (this.translationVisible) {
        this.translationVisible = false
        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.add("translation-show")
        })
        document.querySelector(".translation3").classList.add("translation-show")

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      //有翻译在显示
      else {
        this.translationVisible = true

        document.querySelector(".translation3").classList.remove("translation-show")

        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.remove("translation-show")
        })

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      this.scrollToFocus()
    },

    showTranslation2(num) {
      // 记录点击功能图标
      this.handleClickedFunction(num)
      //激活另一个按钮
      this.translationVisible = true

      //无翻译在显示
      if (this.translationVisible2) {
        this.translationVisible2 = false
        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.add("translation-show")
        })
        document.querySelector(".translation3").classList.add("translation-show")

        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      //有翻译在显示
      else {
        this.translationVisible2 = true
        document.querySelector(".translation3").classList.remove("translation-show")
        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }
      this.scrollToFocus()
    },

    //显示知识点
    showKnowledge(num) {
      // 记录点击功能图标
      this.handleClickedFunction(num)
      if (document.querySelector(".knowledge-show")) {
        this.knowledgeVisible = true
        document.querySelectorAll(".knowledge").forEach((node) => {
          node.classList.remove("knowledge-show")
        })
      } else {
        this.knowledgeVisible = false
        document.querySelectorAll(".knowledge").forEach((node) => {
          node.classList.add("knowledge-show")
        })
      }

      this.scrollToFocus()
    },

    //显示消息
    async toastMessage(message) {
      const toast = await toastController.create({
        message: message,
        duration: 1000,
        position: "middle",
        color: "success",
      })
      await toast.present()
    },

    //显示测试题
    showExamination(num) {
      // 记录点击功能图标
      this.handleClickedFunction(num)
      if (document.querySelector(".examination-show")) {
        this.examinationVisible = true
        document.querySelectorAll(".examination").forEach((node) => {
          node.classList.remove("examination-show")
        })

        this.toastMessage("测试题已关闭。")
      } else {
        this.examinationVisible = false
        document.querySelectorAll(".examination").forEach((node) => {
          node.classList.add("examination-show")
        })

        //页面直接滚动到指定位置
        document.querySelector("#examination").scrollIntoView(true)
        this.toastMessage("测试题已显示在文章最下方。")
      }
    },

    //显示测试题
    showFocus(num = 7) {
      // 记录点击功能图标
      this.handleClickedFunction(num)
      if (document.querySelector(".sentence-focus-show")) {
        this.focusVisible = true
        document.querySelectorAll(".sentence-focus").forEach((node) => {
          node.classList.remove("sentence-focus-show")
        })
      } else {
        this.focusVisible = false
        document.querySelectorAll(".sentence-focus").forEach((node) => {
          node.classList.add("sentence-focus-show")
        })

        document.querySelectorAll(".content").forEach((node2) => {
          node2.classList.remove("contentFocus")
        })
      }

      this.scrollToFocus()
    },

    showNextFocus(num) {
      this.clickedArr.push(num)
      const contentList = document.querySelectorAll(".content")
      let exist = false
      for (let i = 0; i < contentList.length; i++) {
        //存在焦点
        if (contentList[i].classList.contains("contentFocus")) {
          exist = true
          contentList[i].classList.remove("contentFocus")
          if (i == contentList.length - 1) {
            contentList[0].classList.add("contentFocus")
            contentList[0].scrollIntoView(false)
          } else {
            contentList[i + 1].classList.add("contentFocus")
            contentList[i + 1].scrollIntoView(false)
          }
          break
        }
      }

      if (!exist && contentList.length > 0) {
        contentList[0].classList.add("contentFocus")
        contentList[0].scrollIntoView(false)
      }
    },

    //  完形填空  -- 开始
    async showExaminationOptionTable(ev, idx) {
      // const modal = await modalController.create({
      //   component: ModalExamOptions,
      //   componentProps: { examData: this.examinationDataTable[idx] },
      //   cssClass: "common_center_modal_class modal_examination_class",
      // });
      // await modal.present();
      this.closePop()
      setTimeout(() => {
        this.answerPopVisible = true
        this.answerPopId = this.examinationDataTable[idx]
      }, 300)
    },
    closePop() {
      if (this.answerPopVisible) {
        this.answerPopVisible = false
      }
    },
    //处理测试题
    handleExamination(examination) {
      if (!examination) {
        return
      }

      this.examinationDataTable = []

      //找出题目标号
      examination = examination.replace(/\(\s*(\d\d*)\s*\)/gi, (search, p1) => {
        this.examinationDataTable[p1] = { idx: search }
        return `<span class="examination-number" data-idx="${p1}">${search}</span>`
      })

      //找出选项的数字标号，后续还需找出4个选项
      examination = examination.replace(/(\d\d*)\s*、/gi, (search, p1) => {
        return `<span id="examination-option${p1}" class="examination-option">${search}</span>`
      })

      //找出答案
      examination = examination.replace(/【\s*(\d\d*)\s*】/gi, (search, p1) => {
        return `<span id="examination-answer${p1}" class="examination-answer">${search}</span>`
      })

      let elExamination = document.getElementById("examination")

      //向页面输出测试题
      elExamination.innerHTML = examination

      //给题目标号绑定点击事件
      elExamination.querySelectorAll(".examination-number").forEach((node1) => {
        node1.addEventListener("click", (ev) => {
          ev.stopPropagation()
          this.showExaminationOptionTable(ev, node1.dataset.idx)
        })
      })

      this.examinationDataTable.forEach((obj, idx) => {
        //根据选项标号找出4个选项，并保存
        let elExaminationOption = document.getElementById("examination-option" + idx)
        let elTableOption = myCreateElement("table", "examination-option-table")
        if (elExaminationOption) {
          let elExaminationOptionTR = elExaminationOption.closest("tr")
          if (elExaminationOptionTR) {
            elTableOption.appendChild(elExaminationOptionTR.cloneNode(true))
            if (elExaminationOptionTR.nextElementSibling) {
              elTableOption.appendChild(elExaminationOptionTR.nextElementSibling.cloneNode(true))
            }
          }
        }
        this.examinationDataTable[idx].option = elTableOption

        //根据标号找出答案
        let elExaminationAnswer = document.getElementById("examination-answer" + idx)
        if (elExaminationAnswer) {
          let elExaminationAnswerTD = elExaminationAnswer.closest("td")
          elExaminationAnswerTD.style.width = "33.3%"
          this.examinationDataTable[idx].answer = elExaminationAnswerTD.innerHTML
        }
      })
    },

    //  完形填空  -- 结束

    //查询阅读理解文章
    queryReadingArticle() {
      this.ajax.post("/reading/getReadingArticleForApp?readingId=" + this.readingId).then((res) => {
        if (res.data.success) {
          //取到文章对象，赋给全局对象，展示英文标题，填充中文标题
          this.dataObject = res.data.data
          let article = res.data.data

          document.getElementById("knowledge").innerHTML = article.knowledge

          this.handleExamination(article.examination)

          let articleBody = document.querySelector(".articleBody")
          articleBody.innerHTML = ""

          //遍历段落
          article.sectionList.forEach((section) => {
            //创建段落标签
            let sectionDiv = myCreateElement("div", "section")

            //创建英文段落
            let english = myCreateElement("p", "english", "english-font1")
            let indent1 = myCreateElement("span", "indent") //缩进
            english.appendChild(indent1)

            //创建中文段落
            let translation = myCreateElement("p", "translation", "english-font1")
            let indent2 = myCreateElement("span", "indent") //缩进
            translation.appendChild(indent2)

            //遍历段落中的句子
            if (section.sentenceList) {
              section.sentenceList.forEach((sentence) => {
                let sentenceContent = myCreateElement("span", "content")
                sentenceContent.id = "content_" + sentence.sentenceId
                sentenceContent.style["margin-right"] = "0.4rem"

                //创建每一句单独的翻译
                let sentenceTranslation2 = myCreateElement("p", "translation2")
                let content = sentence.content
                sentenceTranslation2.innerText = sentence.translation

                //匹配短语
                if (res.data.readingPhraseList) {
                  res.data.readingPhraseList.forEach((phrase) => {
                    let reg1 = phrase.content.replace(
                      "…",
                      "([a-zA-Z]+)([-'‘’][a-zA-Z]+)?( ([a-zA-Z]+)([-'‘’][a-zA-Z]+)?)*"
                    )
                    let reg = new RegExp(reg1, "gi")
                    content = content.replace(reg, (search) => {
                      return `<span class="phrase" data="${phrase.content}">${search}</span>`
                    })
                  })
                }

                //匹配重点单词，指定词库单词
                if (res.data.list) {
                  res.data.list.forEach((word) => {
                    let reg = new RegExp(
                      "(?<!<div.*)(?<![a-zA-Z]+)(" + word.content + ")(?![a-zA-Z]+)"
                    )
                    content = content.replace(reg, (search) => {
                      return `<div class="course">${search}</div>`
                    })
                  })
                }

                //为每一个单词打上标记，并绑定事件
                content = content.replace(
                  /(?<!<[^>]*?)([a-zA-Z]+)([-'‘’][a-zA-Z]+)?/gim,
                  (search) => {
                    return `<span class="word">${search}</span>`
                  }
                )

                sentenceContent.innerHTML = content

                //在每一句后面插入焦点图标
                let focusFlag = myCreateElement("img", "sentence-focus")
                focusFlag.src =
                  "https://ydl-static.oss-cn-hangzhou.aliyuncs.com/images/lixiao/app/focus-off.png"
                sentenceContent.appendChild(focusFlag)

                //.appendChild(sentenceTranslation2);//为每一句英文后面加上中文翻译
                english.appendChild(sentenceContent) //
                english.appendChild(sentenceTranslation2) //为每一句英文后面加上中文翻译

                let sentenceTranslation = myCreateElement(
                  "span",
                  "sentence-translation",
                  "english-font1"
                )
                sentenceTranslation.innerText = sentence.translation
                translation.appendChild(sentenceTranslation)
              })
            }

            //在每一段后面插入一个操作图片
            //let sectionFlag = myCreateElement("img", "section-flag");
            //sectionFlag.src = "https://ydl-static.oss-cn-hangzhou.aliyuncs.com/images/lixiao/app/flag-red.png"
            //english.appendChild(sectionFlag);

            sectionDiv.appendChild(english)
            sectionDiv.appendChild(translation)

            //创建段落教案
            if (section.knowledge && section.knowledge.trim() != "") {
              let knowledge = myCreateElement("p", "knowledge")
              knowledge.classList.add("knowledge" + section.sectionId)
              knowledge.innerHTML = section.knowledge
              sectionDiv.appendChild(knowledge)
            }

            articleBody.appendChild(sectionDiv)

            //为单词绑定单击事件
            english.querySelectorAll(".word").forEach((el) => {
              el.addEventListener("click", (e) => {
                e.target.classList.add("focusWord")
                this.openPopover(e, e.target.innerText)
              })
            })

            //为短语绑定双击事件
            english.querySelectorAll(".phrase").forEach((el) => {
              el.addEventListener("touchstart", (e) => {
                this.timerTouchstart = setTimeout(() => {
                  this.openPopover(e, el.getAttribute("data"))
                }, 500)
              })

              el.addEventListener("touchmove", () => {
                clearTimeout(this.timerTouchstart)
              })

              el.addEventListener("touchend", () => {
                clearTimeout(this.timerTouchstart)
              })
            })

            //为每句绑定单击事件
            english.querySelectorAll(".sentence-focus").forEach((node1) => {
              node1.addEventListener("click", (ev) => {
                document.querySelectorAll(".content").forEach((node2) => {
                  node2.classList.remove("contentFocus")
                })
                ev.target.parentNode.classList.add("contentFocus")
                this.showFocus()
              })
            })
          })
        }
      })
    },

    saveReadingId() {
      const appointment = this.store.getAppointment()
      this.ajax.post("/record/saveReadingId", {
        aptmId: appointment.aptmId,
        readingId: this.readingId,
      })
    },

    intToStringTime(num) {
      let minutes = parseInt((num / 60).toString())
      let seconds = num % 60
      let strMinutes = minutes < 10 ? "0" + minutes : String(minutes)
      let strSeconds = seconds < 10 ? "0" + seconds : String(seconds)
      return strMinutes + ":" + strSeconds
    },

    //暂时弃用！！！
    unlockButton() {
      setInterval(() => {
        if (this.timerUnlock1 <= 0) {
          this.buttonVisible = true
        }
        this.timerUnlock1--
        this.timerUnlock2++
        this.strTime1 = this.intToStringTime(this.timerUnlock1)
        this.strTime2 = this.intToStringTime(this.timerUnlock2)
      }, 1000)
    },
    storageReadingId() {
      const appointment = this.store.getAppointment()
      appointment.readingId = this.readingId
      this.store.setAppointment(appointment)
    },
  },

  mounted() {
    this.storageReadingId()
    this.userinfo = this.store.getUser()
    this.queryReadingArticle()
    this.saveReadingId()
    this.startReadingArticleLearning()

    //倒计时结束完成练习按钮
    //this.unlockButton();
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.title {
  text-align: center;
  font-size: inherit;
  font-weight: 700;
}

.titleTranslation {
  margin: 4vw;
  //font-size: inherit;
  line-height: inherit;
  display: flex;
  justify-content: center;
  text-align: center;
}

.topbar img {
  height: 1.6rem;
  width: 1.6rem;
  margin-right: 0.5rem;
}

ion-content {
  --color: black;
}

.essay-generate {
  position: relative;
  height: 100%;
  width: 100%;
  padding-bottom: 13%;

  ion-content::part(background) {
    background: transparent;
  }

  &_bg {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }

  &_header {
    width: 100%;
    height: 10%;
    padding: 5%;

    &-title {
      max-width: 60%;
    }

    &-back {
      width: 8%;
      z-index: 10;
    }

    &-bar {
      width: 2.5vw;
      z-index: 10;
    }

    .right-bar {
      &_icon {
        width: 1.15rem;
        height: 1.15rem;
        position: relative;
        overflow: hidden;

        img {
          height: 100%;
          transform: translateX(-2rem);
        }

        .normal-img {
          filter: drop-shadow(2rem 0 0 #3f4140);
        }

        .clicked-img {
          filter: drop-shadow(2rem 0 0 #0dcb8b);
        }
      }

      &_drop {
        width: 1.15rem;
        height: 1.15rem;
        position: relative;

        &_options {
          position: absolute;
          top: 130%;
          left: -100%;
          width: 300%;
          height: 0;
          z-index: 6;
          border-radius: 2vw;
          background-color: #ffffff;
          box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.1);
          overflow-y: scroll;
          transition: height 0.2s ease-in;

          & > span {
            display: block;
            width: 100%;
            height: 100%;
            padding: 10px 11px 11px 8px;
            text-align: center;

            &:hover {
              background-color: #f1fcfa;
            }
          }
        }

        .options_active {
          height: 800%;
          transition: height 0.2s ease-out;
        }
      }
    }
  }

  &_main {
    width: 100%;
    height: 100%;
    border-radius: 3vw;
    overflow-y: scroll;
  }

  &_content {
    flex: 1;
    width: 100%;
    padding: 0 5% 10% 5%;
    position: relative;

    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0 5% 5% 5%;
      z-index: -1;
    }

    .essay-place {
      width: 100%;
      display: flex;

      &_content {
        width: 100%;
        height: 100%;
        padding: 3%;
        display: flex;
        //background-color: #D9D9D9;
        border: 2px solid #d9d9d9;
        border-radius: 3vw;
      }
    }
  }

  &_footer {
    width: 100%;
    color: #606266;
    text-align: right;

    &-create {
      &::part(native) {
        background-color: #0bbb7d;
      }
    }

    &-practice {
      width: 60%;

      &::part(native) {
        background-color: #f8ac17;
        width: 40vw;
      }
    }
  }

  &_bottom {
    position: absolute;
    bottom: 2.5vh;
    left: 0;
    width: 100%;
    padding: 0 5% 5%;

    .hollow {
      width: 80%;
      height: 9vw;
      //margin-left: 3vw;
    }
    .button-outline::part(native){
      background-color: #0dcb8b;
      color: white;
    }

    .end {
      width: 90%;
      margin: 0;
      position: relative;

      &-suffix {
        position: absolute;
        right: 0;
        top: -39%;
        width: 20vw;
      }

      &-text {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
      }

      &-suffix-text {
        position: absolute;
        right: 7%;
        top: -32%;
        font-size: 2.2vw;
        color: var(--font-golden-color);
      }
    }
  }
}
</style>

<style scoped>
.popover-examination-option-class {
  --height: 8rem;
  --width: 80vw;
}

.reading-article-main-content {
  //background-color: white;
  color: black;
}

.indent {
  width: 4vw;
  display: inline-block;
}

.english {
  //font-family: 宋体;
  font-size: 1.1em;
  line-height: 1.5rem;
}

.english-font1 {
  font-size: var(--inherit-size);
  line-height: 1.5rem;
}

.english-font2 {
  font-size: 1.25rem;
  line-height: 1.7rem;
}

.english-font3 {
  font-size: 1.4rem;
  line-height: 2rem;
}

.english-font1 h2 {
  font-size: 1.3rem !important;
  line-height: inherit;
}

.english-font2 h2 {
  font-size: 1.45rem !important;
  line-height: inherit;
}

.english-font3 h2 {
  font-size: 1.6rem !important;
  line-height: inherit;
}

.translation {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
}

.translation2 {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
  font-size: inherit;
}

.translation3 {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
}

.translation-show {
  display: block;
  line-height: 2em;
  //font-size: 1.1em;
}

.sentence-translation {
  font-size: inherit;
}

.course {
  border-bottom: #21c73c dashed;
  display: inline;
}

.focusWord {
  color: white;
  background-color: #21c73c;
}

.knowledge {
  line-height: inherit;
  padding: 2vw;
  display: none;
  border: 1px dashed gray;
}

.knowledge-show {
  display: block;
}

.examination {
  line-height: inherit;
  padding: 2vw;
  display: none;
  border: 1px dashed gray;
}

.examination-show {
  display: block;
  word-break: break-word;

  & tr:nth-child(1) td {
    width: auto;
  }

  & td {
    word-break: break-word;
    vertical-align: top;
  }
}

.examination-number {
  color: red;
  text-decoration: underline;
}

.examination-option {
  color: green;
}

.examination-answer {
  color: purple;
}

.phrase {
  border-bottom: 2px dashed red;
}

.section-flag {
  width: 1.2em;
  height: 1.2em;
}

.sentence-focus {
  width: 1.2em;
  height: 1.2em;
  margin-left: 2vw;
  margin-right: 2vw;
  vertical-align: middle;
  display: none;
}

.sentence-focus-show {
  display: inline;
}

.content {
  height: 1.5rem;
  line-height: inherit;
}

.contentFocus {
  padding: 0 0.5rem;
  height: 1.5rem;
  line-height: inherit;
  color: white;
  background-color: #28ba62;
}

#examination :has(> .examination-answer) {
  word-break: break-word;
}
</style>
<style>
.modal_examination_class {
  --height: 36rem;
  --max-height: 0;
  --min-height: 16rem;
}

.examination-show td,
.examination-show tr {
  vertical-align: top;
}

.examination-option-table {
  width: 100%;
}

.examination-option-table td {
  word-break: break-all;
  padding-right: 0.2rem;
}
</style>
